/*@ngInject*/
const FormComponentRenderingUtil = function ($rootScope, $compile, $templateCache, $timeout, $q, fieldType, umsLog, watchManagerUtil) {

    let componentDirectory = '/formViewer/component/',
        structureDirectory = '/formViewer/structure/',
        editorDirectory = '/formViewer/editor/',
            componentLookup = {},
            formTpl = $($templateCache.get(componentDirectory + 'formPlaceholder.tpl.html')),
            sectionTpl = $compile($($templateCache.get(componentDirectory + 'sectionPlaceholder.tpl.html'))),
            supplementalFormTpl = $compile($($templateCache.get(componentDirectory + 'supplementalFormPlaceholder.tpl.html'))),
            rowTpl = $compile($($templateCache.get(structureDirectory + 'row/rowPlaceholder.tpl.html'))),
            repeatingRowTpl = $compile($($templateCache.get(structureDirectory + 'repeatingRow/repeatingRowPlaceholder.tpl.html'))),
            configurableRowTpl = $compile($($templateCache.get(editorDirectory + 'row/rowEditorPlaceholder.tpl.html'))),
            configurableComponentTpl = $compile($($templateCache.get(editorDirectory + 'componentEditorPlaceholder.tpl.html'))),
            configurableSectionTpl = $compile($($templateCache.get(editorDirectory + 'section/sectionEditorPlaceholder.tpl.html')));

        componentLookup[fieldType.TEXT_INPUT] = $compile($($templateCache.get(componentDirectory + 'textInput/textInputPlaceholder.tpl.html'))[0]);
        componentLookup[fieldType.DROP_DOWN] = $compile($($templateCache.get(componentDirectory + 'dropdown/formDropdownPlaceholder.tpl.html'))[0]);
        componentLookup[fieldType.LABEL] = $compile($($templateCache.get(componentDirectory + 'label/labelPlaceholder.tpl.html'))[0]);
        componentLookup[fieldType.YES_NO] = $compile($($templateCache.get(componentDirectory + 'yesNoRadio/yesNoRadioPlaceholder.tpl.html'))[0]);
        componentLookup[fieldType.SPACER] = $compile($($templateCache.get(componentDirectory + 'spacer/spacerPlaceholder.tpl.html')));
        componentLookup[fieldType.CHECK_BOX] = $compile($($templateCache.get(componentDirectory + 'checkbox/checkboxPlaceholder.tpl.html'))[0]);
        componentLookup[fieldType.TEXT_AREA] = $compile($($templateCache.get(componentDirectory + 'textarea/textAreaPlaceholder.tpl.html')));
        componentLookup[fieldType.BUTTON] = $compile($($templateCache.get(componentDirectory + 'functionButton/buttonPlaceholder.tpl.html')));
        componentLookup[fieldType.LINK_BUTTON] = $compile($($templateCache.get(componentDirectory + 'urlLink/urlLinkPlaceholder.tpl.html')));
        componentLookup[fieldType.CHECK_BOX_GROUP] = $compile($($templateCache.get(componentDirectory + 'checkboxGroup/checkboxGroupPlaceholder.tpl.html')));
        componentLookup[fieldType.MULTI_SELECT] = $compile($($templateCache.get(componentDirectory + 'multiSelect/multiSelectPlaceholder.tpl.html')));
        componentLookup[fieldType.CALENDAR] = $compile($($templateCache.get(componentDirectory + 'calendar/calendarPlaceholder.tpl.html'))[0]);
        componentLookup[fieldType.CLASSCODEFINDER] = $compile($($templateCache.get(componentDirectory + 'classCode/classCodePlaceholder.tpl.html')));
        componentLookup[fieldType.RADIO_BUTTON_GROUP] = $compile($($templateCache.get(componentDirectory + 'radioButtonGroup/radioButtonGroupPlaceholder.tpl.html')));
        componentLookup[fieldType.FUNCTION_BUTTON] = $compile($($templateCache.get(componentDirectory + 'functionButton/functionButtonPlaceholder.tpl.html')));
        componentLookup[fieldType.UPLOAD_ATTACHMENT_BUTTON] = $compile($($templateCache.get(componentDirectory + 'uploadAttachment/uploadAttachmentPlaceholder.tpl.html')));
        componentLookup[fieldType.FORM_SUMMARY_GRID] = $compile($($templateCache.get(componentDirectory + 'formSummary/formSummaryGridPlaceholder.tpl.html')));
        componentLookup[fieldType.ROWREPEATER] = $compile($($templateCache.get(componentDirectory + 'rowRepeater/rowRepeaterPlaceholder.tpl.html')));

        this.createComponentByType = function (field, parentRowContainer, hideLabel) {
            let newScope,
                newFieldLink;

            this.validateContainer(parentRowContainer);

            newScope = $rootScope.$new(true);
            newScope.fieldStructure = field;
            newScope.hideLabel = hideLabel;

            newFieldLink = componentLookup[field.uiField.fieldTemplate.type];

            if (newFieldLink) {
                newFieldLink(newScope, function (clone) {
                    parentRowContainer.append(clone);
                });
            }
        };

        this.createRow = function (row, parentRowContainer, advancedInsertion, insertAfter) {
            let newScope = $rootScope.$new(true);

            this.validateContainer(parentRowContainer);

            newScope.row = row;

            return rowTpl(newScope, function (clone) {
                let cloneElement = $(clone);

                row.viewContainer = cloneElement.find('.formRowContainer');

                if (advancedInsertion) {
                    if (insertAfter) {
                        cloneElement.insertAfter(parentRowContainer);
                    }
                    else {
                        cloneElement.insertBefore(parentRowContainer);
                    }
                }
                else {
                    parentRowContainer.append(cloneElement);
                }

                return clone;
            });
        };

        this.createRepeatingRow = function (row, parentRowContainer, hideRowNumbers, configurable) {
            let newScope = $rootScope.$new(true);

            this.validateContainer(parentRowContainer);

            newScope.row = row;
            newScope.hideRowNumbers = hideRowNumbers;
            newScope.configurable = configurable;

            return repeatingRowTpl(newScope, function (clone) {
                let cloneElement = $(clone);

                row.viewContainer = cloneElement.find('.formRowContainer');

                parentRowContainer.append(cloneElement);

                return clone;
            });
        };

        this.createConfigurableRowComponent = function (row, targetContainer, advancedInsertion, insertAfter) {
            let newScope = $rootScope.$new(true);

            this.validateContainer(targetContainer);

            newScope.rowStructure = row;
            newScope.resetRow = this.resetRowEditor.bind(this);

            configurableRowTpl(newScope, function (clone) {
                let selectionContainer = $(clone).find('.rowSelectionContainer');

                if (advancedInsertion) {
                    if (insertAfter) {
                        clone.insertAfter(targetContainer);
                    }
                    else {
                        clone.insertBefore(targetContainer);
                    }
                }
                else {
                    targetContainer.append(clone);
                }

                this.createRow(row, selectionContainer);
            }.bind(this));
        };

        this.createRowRepeaterComponent = function (row, parentRowContainer, configurable) {
            let newScope = $rootScope.$new(true);

            this.validateContainer(parentRowContainer);

            newScope.row = row;
            newScope.formId = row.parentForm.root ? row.parentForm.id : row.parentForm.rootFormId;
            newScope.configurable = configurable;

            componentLookup[fieldType.ROWREPEATER](newScope, function (clone) {
                parentRowContainer.append(clone);
            });
        };

        this.createConfigurableRowRepeaterComponent = function (rowStructure, parentRowContainer, advancedInsertion, insertAfter) {

            let configurableRowScope = $rootScope.$new(true);

            this.validateContainer(parentRowContainer);

            // create configurable row
            configurableRowScope.rowStructure = rowStructure;
            configurableRowScope.resetRow = this.resetRowEditor.bind(this);

            configurableRowTpl(configurableRowScope, function (configurableRowClone) {
                let configurableRowSelectionContainer = $(configurableRowClone).find('.rowSelectionContainer');

                if (advancedInsertion) {
                    if (insertAfter) {
                        configurableRowClone.insertAfter(parentRowContainer);
                    }
                    else {
                        configurableRowClone.insertBefore(parentRowContainer);
                    }
                }
                else {
                    parentRowContainer.append(configurableRowClone);
                }

                // create row component
                let newRowScope = $rootScope.$new(true);
                newRowScope.row = rowStructure;

                this.validateContainer(configurableRowSelectionContainer);

                return rowTpl(newRowScope, function (rowClone) {
                    let newRowElement = $(rowClone),
                        formRowContainer = newRowElement.find('.formRowContainer');

                    rowStructure.viewContainer = formRowContainer;

                    configurableRowSelectionContainer.append(newRowElement);

                    this.validateContainer(formRowContainer);
                    this.createRowRepeaterComponent(rowStructure, formRowContainer, true);

                    return rowClone;
                }.bind(this));


            }.bind(this));
        };

        this.createSupplementalFormComponent = function (row, parentRowContainer) {
            let defer = $q.defer(),
                newScope = $rootScope.$new(true);

            this.validateContainer(parentRowContainer);

            newScope.row = row;
            newScope.formId = row.formModel.id;

            supplementalFormTpl(newScope, function (clone) {
                parentRowContainer.append(clone);
                defer.resolve();
            });

            return defer.promise;
        };

        this.createSectionComponent = function (section, parentFormContainer, shouldRenderEntireForm) {
            let newSectionScope = $rootScope.$new(true);
            newSectionScope.formId = section.rootFormId;
            newSectionScope.sectionStructure = section;

            this.validateContainer(parentFormContainer);

            sectionTpl(newSectionScope, (clone) => {
                const compiledSection = $(clone);

                section.viewContainer =  compiledSection;
                section.addedToView = true;

                parentFormContainer.append(clone);

                if (!shouldRenderEntireForm) {
                    compiledSection.addClass('rendering');
                }
            });
        };

        this.createConfigurableSectionComponent = function (section, parentFormContainer, shouldRenderEntireForm) {
            let newScope = $rootScope.$new(true);

            this.validateContainer(parentFormContainer);

            newScope.formId = section.rootFormId;
            newScope.sectionStructure = section;
            newScope.resetComponent = this.resetSectionEditor.bind(this);

            configurableSectionTpl(newScope, function (clone) {
                let selectionContainer = $(clone).find('.sectionSelectionContainer');
                parentFormContainer.append(clone);
                this.createSectionComponent(section, selectionContainer, shouldRenderEntireForm);
            }.bind(this));
        };

        this.createConfigurableSection = function (sectionStructure, dropZoneSection, insertAfter) {
            let newScope = $rootScope.$new(true),
                shouldRenderEntireForm = true,
                advancedInsertion = false;

            this.validateContainer(dropZoneSection);

            newScope.formId = sectionStructure.rootFormId;
            newScope.sectionStructure = sectionStructure;
            newScope.resetComponent = this.resetSectionEditor.bind(this);

            configurableSectionTpl(newScope, function (clone) {
                let selectionContainer = $(clone).find('.sectionSelectionContainer'),
                    defaultRow = sectionStructure.rowList[0],
                    defaultField = defaultRow.fieldStructureList[0],
                    formSectionContainer,
                    formRowContainer;

                this.createSectionComponent(sectionStructure, selectionContainer, shouldRenderEntireForm);

                formSectionContainer = $(clone).find('.formSection');
                this.createConfigurableRowComponent(defaultRow, formSectionContainer, advancedInsertion, insertAfter);

                formRowContainer = $(clone).find('.formRowContainer');
                this.createConfigurableComponent(defaultField, formRowContainer);

                if (insertAfter) {
                    clone.insertAfter(dropZoneSection);
                }
                else {
                    clone.insertBefore(dropZoneSection);
                }
            }.bind(this));
        };

        this.createConfigurableSectionBefore = function (sectionStructure, dropZoneSection) {
            let insertAfter = false;
            this.createConfigurableSection(sectionStructure, dropZoneSection, insertAfter);
        };

        this.createConfigurableSectionAfter = function (sectionStructure, dropZoneSection) {
            let insertAfter = true;
            this.createConfigurableSection(sectionStructure, dropZoneSection, insertAfter);
        };

        this.createFormComponent = function () {
            return formTpl.clone();
        };

        this.createConfigurableComponentBefore = function (fieldStructure, targetSibling, hideLabel) {
            let newScope = this.createConfigurableComponentScope(fieldStructure);

            this.validateContainer(targetSibling);

            configurableComponentTpl(newScope, function (clone) {
                let configurableComponent = $(clone),
                    selectionContainer = configurableComponent.find('.selectionContainer');

                configurableComponent.insertBefore(targetSibling);
                this.createComponentByType(fieldStructure, selectionContainer, hideLabel);
            }.bind(this));
        };

        this.createConfigurableComponentAfter = function (fieldStructure, targetSibling, hideLabel) {
            let newScope = this.createConfigurableComponentScope(fieldStructure);

            this.validateContainer(targetSibling);

            configurableComponentTpl(newScope, function (clone) {
                let configurableComponent = $(clone),
                    selectionContainer = configurableComponent.find('.selectionContainer');

                configurableComponent.insertAfter(targetSibling);
                this.createComponentByType(fieldStructure, selectionContainer, hideLabel);
            }.bind(this));
        };

        this.createConfigurableComponentScope = function (fieldStructure) {
            let newScope = $rootScope.$new(true);
            newScope.componentStructure = fieldStructure;
            newScope.componentStructure.isConfigurableComponent = true;
            newScope.formId = fieldStructure.rootFormId;
            newScope.isDraggable = fieldStructure.parentForm.hasWriteAccess;
            newScope.resetComponent = this.resetComponentEditor.bind(this);
            return newScope;
        };

        this.createConfigurableComponent = function (fieldStructure, parentRowContainer, hideLabel) {
            let newScope = this.createConfigurableComponentScope(fieldStructure);

            this.validateContainer(parentRowContainer);

            configurableComponentTpl(newScope, function (clone) {
                let selectionContainer = $(clone).find('.selectionContainer');
                parentRowContainer.append(clone);
                this.createComponentByType(fieldStructure, selectionContainer, hideLabel);
            }.bind(this));
        };

        this.validateContainer = function (container) {
            let result = true;

            if (container.length < 1) {
                umsLog.error('Container does not exist or is empty');
                result = false;
            }
            else if (container.length > 1) {
                umsLog.error('Multiple containers exist when only 1 is expected.');
                result = false;
            }

            return result;
        };

        this.resetComponentEditor = function (container, fieldStructureId) {
            let className = '.componentEditor.' + fieldStructureId;
            watchManagerUtil.resetScopeForComponentId(fieldStructureId);
            this.resetComponentsByClassName(container, className);
        };

        this.resetSectionEditor = function (container, sectionStructure) {
            let className = '.sectionEditor.' + sectionStructure.sectionStructureId;
            this.clearDomReferences([sectionStructure]);
            this.resetComponentsByClassName(container, className);
        };

        this.resetRowEditor = function (container, rowStructure) {
            let className = '.rowEditor.' + rowStructure.rowStructureId;
            this.clearDomReferences([rowStructure]);
            this.resetComponentsByClassName(container, className);
        };

        this.resetAllSections = function (container, formName, formId, sectionList, isSupplemental) {
             let className = '.' + formName + ' .formSectionContainer';

            this.clearDomReferences(sectionList);
            this.resetComponentsByClassName(container, className, isSupplemental);

            if (isSupplemental) {
                watchManagerUtil.resetByFormId(formId);
            }
            else {
                watchManagerUtil.reset();
            }
        };

        this.resetComponentsByClassName = function (container, className, isSupplemental) {
            var scopeList = !!isSupplemental ? container.find(className + ' .ng-scope').parent() : container.find(className + ' .ng-scope'),
                isolateScopeList = !!isSupplemental ? container.find(className + ' .ng-isolate-scope').parent() : container.find(className + ' .ng-isolate-scope');

            this.manuallyDestroyDomScope(scopeList, isolateScopeList);
            this.clearContent(container, className);
        };

        this.clearContent = function (container, className) {
            container.find(className, '.').remove();
        };

        this.clearDomReferences = function (rootSectionList) {
            function clearSectionDomReferences(sectionList) {
                _.each(sectionList, function (section) {
                    section.viewContainer = null;
                    delete section.viewContainer;

                    clearRowDomReferences(section.rowList);
                });
            }

            function clearRowDomReferences(rowList) {
                _.each(rowList, function (row) {
                    row.viewContainer = null;
                    delete row.viewContainer;

                    if (row.sectionList) {
                        clearSectionDomReferences(row.sectionList);
                    }
                });
            }

            clearSectionDomReferences(rootSectionList);
        };

        this.manuallyDestroyDomScope = function (scopeList, isolateScopeList) {
            let scope;

            _.each(scopeList, function (listItem) {
                scope = angular.element(listItem).scope();
                if (scope) {
                    scope.$destroy();
                }
            });

            _.each(isolateScopeList, function (listItem) {
                scope = angular.element(listItem).isolateScope();
                if (scope) {
                    scope.$destroy();
                }
            });
        };
    };

angular.module('umFormViewer')
    .service('formComponentRenderingUtil', FormComponentRenderingUtil);
